/* v028 (22/10/2026) · Halloween : prix -20 % dans le parcours en étapes de la fiche Challenge (écran formule, écran durée, récapitulatif, barre du bas, bouton de commande). Chargé entre v21-app-b et v21-app-c : il enveloppe les fonctions d'affichage de V21A.R le temps du rendu (prix remplacés par les prix remisés, puis remis en place), sans toucher au sélecteur Elkad ni au panier. Les prix au repas « dès » des formules sont ceux de 8 semaines après remise. Ne fait rien hors de la fenêtre Halloween (window.V28HW, posé dans le head). */
(function(){
  var A = window.V21A, P = window.V28P;
  if (!A || !A.R || !P || !P.on() || !P.np) return;
  var U = {'challenge-100-shakes': '2,42', 'challenge-2-par-jour': '3,43', 'challenge-100-plats-chauds': '3,42', 'challenge-3-par-jour': '3,31'};
  try { var F = A.F(); Object.keys(U).forEach(function(k){ if (F[k]) F[k].u = U[k] + '&nbsp;€'; }); } catch (e) {}
  var esc = A.esc || P.es, TAG = '<p class="hw-tag">Halloween&nbsp;: -20&nbsp;% déjà déduit, sans code</p>';
  function swap(S){
    var bk = [], pr = [];
    function set(o, k, v){
      for (var i = 0; i < bk.length; i++) if (bk[i][0] === o && bk[i][1] === k) return;
      bk.push([o, k, o[k]]); if (k !== 'sp') pr.push([o[k], v]); o[k] = v;
    }
    (S.formulas || []).forEach(function(x){ if (x.from) set(x, 'from', P.np(x.from)); });
    if (S.f && S.f.from) set(S.f, 'from', P.np(S.f.from));
    (S.durs || []).forEach(function(d){ if (d.pr) { set(d, 'sp', P.sp(d)); set(d, 'pr', P.np(d.pr)); } });
    if (S.dur && S.dur.pr) { set(S.dur, 'sp', P.sp(S.dur)); set(S.dur, 'pr', P.np(S.dur.pr)); }
    return {pr: pr, back: function(){ for (var i = bk.length - 1; i >= 0; i--) bk[i][0][bk[i][1]] = bk[i][2]; }};
  }
  function post(h, pr){
    if (typeof h !== 'string') return h;
    pr.forEach(function(x){
      var e = esc(x[1]), s = P.hp(x[0]);
      ['b', 'strong', 'span'].forEach(function(t){ h = h.split('<' + t + '>' + e + '</' + t + '>').join('<' + t + '>' + s + '</' + t + '>'); });
    });
    return h;
  }
  ['s1', 's2', 's3', 'side', 'sum', 'go'].forEach(function(k){
    var f = A.R[k];
    if (typeof f !== 'function') return;
    A.R[k] = function(S){
      if (!S || !P.on()) return f.apply(this, arguments);
      var w = swap(S), h;
      try { h = f.apply(this, arguments); } finally { w.back(); }
      if (k !== 'go') h = post(h, w.pr);
      if ((k === 's1' || k === 's2') && typeof h === 'string') h = h.replace('</h1>', '</h1>' + TAG);
      return h;
    };
  });
})();